import { useEffect, useState } from "react";
import DoctorDrugInfo from "./DoctorDrugInfo.component";
import DoctorDrugModal from "../../components/DoctorDrugModal/DoctorDrugModal.component";
import { IDoctor, IPlan } from "../../interfaces/api";

const DoctorsDrugsTile = ({ planData }: { planData: IPlan }) => {
  const [componentList, setComponentList] = useState<JSX.Element[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [planDoctors, setPlanDoctors] = useState<IDoctor[]>(() => {
    const savedData = sessionStorage.getItem(
      `planDoctors${planData.pbpName}${planData.pbp}`
    );
    return savedData ? JSON.parse(savedData) : [];
  });

  useEffect(() => {
    const newComponentList = planDoctors?.map((doctor: IDoctor, index) => (
      <DoctorDrugInfo doctor={doctor} key={index} planData={planData} />
    ));

    newComponentList && setComponentList(newComponentList);
  }, [planDoctors, planData]);

  const confirmDoctors = (data: IDoctor[]) => {
    setPlanDoctors(data);
    sessionStorage.setItem(
      `planDoctors${planData.pbpName}${planData.pbp}`,
      JSON.stringify(data)
    );
  };

  const openDoctorModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setOpenModal(true);
  };

  const togglePopup = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowPopup(!showPopup);
  };

  return (
    <>
      <div className="cell small-12">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div className="edit-line">
            <h3
              className="text-uppercase color-secondary"
              style={{ fontSize: "22px" }}
            >
              Doctors
            </h3>
            <div className="button-wrapper">
              <button
                type="button"
                className="color-primary text-underline"
                style={{ fontWeight: 500, cursor: "pointer" }}
                onClick={openDoctorModal}
              >
                Add/Edit Your Doctors
              </button>
              <button
                type="button"
                className="color-primary text-underline"
                style={{
                  color: "#1B54C2",
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: 500,
                }}
                onClick={togglePopup}
              >
                Is your doctor not covered?
              </button>
            </div>
          </div>
          {showPopup && (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                lineHeight: "42px",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#F5F9FD",
                border: "1px solid #ccc",
                padding: "80px 56px",
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
                zIndex: 9999,
                fontSize: 25,
                color: "#212126",
                width: "80%",
                maxWidth: "820px",
                minHeight: "335px",
                fontWeight: "normal",
              }}
            >
              <button
                type="button"
                onClick={togglePopup}
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  backgroundColor: "#DAE9FF",
                  border: "none",
                  borderRadius: 0,
                  fontSize: 30,
                  cursor: "pointer",
                  color: "#0065F2",
                  width: 58,
                  height: 58,
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    '&times; <span class="screen-reader-text">Close</span>',
                }}
              ></button>
              If your current doctor is not covered, rest assured we're here to
              assist. We can help you find a doctor who is in-network with
              Alignment Health Plan. Give us a call at{" "}
              <span className="color-primary text-underline">
                <a href="tel:18002938272">1-800-293-8272</a>
              </span>{" "}
              (TTY: 711).
            </div>
          )}
        </div>
        {componentList}
      </div>
      {openModal && (
        <DoctorDrugModal
          setOpenModal={setOpenModal}
          confirmDoctors={confirmDoctors}
          actualData={planDoctors}
        />
      )}
    </>
  );
};

export default DoctorsDrugsTile;
